module.exports = __webpack_public_path__ + "static/media/CarouselRightArrow.494b6326.svg";